// extracted by mini-css-extract-plugin
export default {"root":"styles_root__vblMH","healthFilterButtonLabel":"styles_healthFilterButtonLabel__z1Zmk","legendContainer":"styles_legendContainer__mDhAN","icon":"styles_icon__1fTei"};